import React, {useContext} from "react";
import "./SignatureTypeTab.scss"

interface SignatureTypeTabProps {
    text: string;
    type: string;
    onSetSignatureType: (type: string) => void;
    isActive: boolean;
}


export const SignatureTypeTab: React.FunctionComponent<SignatureTypeTabProps> = (props) => {
    return <div className={'signature-type-tab ' + (props.isActive ? 'active' : '')} onClick={() => {
        props.onSetSignatureType(props.type);
    }}>{props.text}</div>
}
